import { Icon as e } from "./icons/icons.js";
import "./icons/index.js";
import { InputGroup as t, InputGroupAddon as n, InputGroupInput as r } from "./input-group.js";
import { jsx as i, jsxs as a } from "react/jsx-runtime";
//#region src/components/search-bar.tsx
var o = ({ onChange: o, placeholder: s }) => /* @__PURE__ */ a(t, {
	className: "rounded-sm border",
	children: [/* @__PURE__ */ i(r, {
		placeholder: s,
		onChange: o
	}), /* @__PURE__ */ i(n, { children: /* @__PURE__ */ i(e, { name: "search" }) })]
});
//#endregion
export { o as SearchBar };
